import classNames from 'classnames';
import React, { FC, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import Icon from './Icon';

type AppModalProps = {
  visible: boolean;
  show: () => void;
  close: () => void;
  IconClose?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
};

const Modal: FC<AppModalProps> = ({ visible, className, show, close, IconClose, children }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  if (!mounted) return null;

  const modalContent = visible ? (
    <div className={classNames('animated-fade-in duration-300 fixed inset-0 overflow-y-auto', className || 'z-50')} style={{ zIndex: 9999 }}>
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-4">
        <div className="fixed inset-0 bg-white/20 backdrop-blur-md" aria-hidden="true" onClick={close} style={{ zIndex: 9998 }}></div>
        <div className={classNames('relative bg-white text-dark rounded-lg text-left overflow-hidden shadow-xl transform transition-all max-w-lg w-full mx-auto')} style={{ zIndex: 9999 }}>
          <div className="absolute top-3 right-3" style={{ zIndex: 10000 }}>
            <button type="button" onClick={close} className="px-3 py-2 cursor-pointer text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors" aria-label="Cerrar modal">
              {IconClose ?? <Icon name="close" size={20} />}
            </button>
          </div>
          <div className="px-6 py-6">{children}</div>
        </div>
      </div>
    </div>
  ) : null;

  return modalContent ? createPortal(modalContent, document.body) : null;
};

export default Modal;
